module.exports = __webpack_public_path__ + "img/ray.aea29a7e.jpg";